import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { NameValue } from '../global/types';
import { AbmLoggerService } from './abm-logger.service';

export class AbmScript extends NameValue {
    public loaded: boolean;
    constructor(name: string, src: string, loaded = false) {
        super(name, src);
        this.loaded = loaded;
    }
}

@Injectable({
    providedIn: 'root',
})
export class AbmScriptService {
    private scripts: AbmScript[] = [];

    constructor(private _logger: AbmLoggerService) { }

    public load(script: AbmScript): Observable<AbmScript> {
        return new Observable<AbmScript>((observer: Observer<AbmScript>) => {
            const existingScript = this.scripts.find(s => s.name === script.name);

            // Complete if already loaded
            if (existingScript && existingScript.loaded) {
                this._logger.info('Script ' + existingScript.name + ' already loaded');
                observer.next(existingScript);
                observer.complete();
            } else {
                // Add the script
                this.scripts.push(script);

                // Load the script
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.src = (script.value as string);

                scriptElement.onload = () => {
                    script.loaded = true;
                    observer.next(script);
                    observer.complete();
                };

                scriptElement.onerror = (error: any) => {
                    observer.error('Cannot load script ' + script.value);
                };

                document.getElementsByTagName('head')[0].appendChild(scriptElement);
                this._logger.info('Loaded script:' + script.name);
            }
        });
    }
}
